import { isFetchBaseQueryError } from "@/utils/rtkError";

export type BeneficiaryTemplatesVerificationResult =
  | "available"
  | "no-templates"
  | "load-failed";

type BeneficiaryTemplatesResponse = {
  data?: readonly unknown[];
};

type BeneficiaryTemplatesRefetch = () => {
  unwrap: () => Promise<BeneficiaryTemplatesResponse>;
};

/** 400 from journal-payment means the corridor has no payment rail / templates. */
export function classifyBeneficiaryTemplatesFetchError(
  error: unknown
): "no-templates" | "load-failed" {
  if (isFetchBaseQueryError(error) && error.status === 400) {
    return "no-templates";
  }
  return "load-failed";
}

export function evaluateBeneficiaryTemplatesResponse(
  response: BeneficiaryTemplatesResponse | undefined
): BeneficiaryTemplatesVerificationResult {
  if (response?.data && response.data.length > 0) {
    return "available";
  }
  return "no-templates";
}

export async function verifyBeneficiaryTemplates(
  refetch: BeneficiaryTemplatesRefetch
): Promise<BeneficiaryTemplatesVerificationResult> {
  try {
    const response = await refetch().unwrap();
    return evaluateBeneficiaryTemplatesResponse(response);
  } catch (error) {
    return classifyBeneficiaryTemplatesFetchError(error);
  }
}
